import { Fragment } from "react";
const Button = (props) => {
  const icon = props.icon ? props.icon : false;
  const iconRight = props.iconRight ? props.iconRight : false;
  const loading = props?.loading || false;
  const disabled = props?.disabled || false;

  return (
    <Fragment>
      {!loading && (
        <button
          className={`btn ${props.hide ? "d-none" : ""} ${disabled ? "btn-dark w-auto me-2" : props.button}`}
          onClick={props.onClick}
          disabled={disabled}
        >
          <div className="d-flex align-items-center justify-content-center gap-2">
            {icon && <i className={props.icon} style={{ color: 'inherit' }}></i>}
            {props.title}
            {iconRight && <i className={props.iconRight} style={{ color: 'inherit' }}></i>}
          </div>
        </button>
      )}

      {loading && (
        <button className={`btn ${props.button}`} disabled>
          <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Loading...
        </button>
      )}
    </Fragment>
  );
};

export default Button;
